import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeart = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.08047 11.2574L9.08027 16.6515C9.3293 16.8753 9.65801 17 10 17C10.342 17 10.6707 16.8753 10.9197 16.6515L16.9195 11.2574C17.9289 10.3525 18.5 9.08312 18.5 7.75618V7.57072C18.5 5.33571 16.8232 3.43003 14.5355 3.06232C13.0215 2.81932 11.4809 3.29574 10.3984 4.3381L10 4.7218L9.60156 4.3381C8.51914 3.29574 6.97852 2.81932 5.46445 3.06232C3.17676 3.43003 1.5 5.33571 1.5 7.57072V7.75618C1.5 9.08312 2.07109 10.3525 3.08047 11.2574Z",
		fill: "#0D2976"
	})
});
export default SvgHeart;
